export const GET_SUGGESTIONS = "GET_SUGGESTIONS";
export const SET_SUGGESTIONS = "SET_SUGGESTIONS";
export const SET_ERROR = "SET_ERROR";
export const GET_WEATHER = "GET_WEATHER";
export const ADD_ITEM = "ADD_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
